"use strict";

const showHighlightsCheckbox = document.getElementById('showEvents');
const sortLiveSelect = document.querySelector('.livearticle__events_order');
function toggleHighlightedArticles(checked) {
  const liveArticles = document.querySelectorAll('.livearticle_event');
  for (let i = 0; i < liveArticles.length; i++) {
    const liveArticle = liveArticles[i];
    if (checked && !liveArticle.classList.contains('is-highlight')) liveArticle.style.display = 'none';
    if (!checked && !liveArticle.classList.contains('is-highlight')) liveArticle.style.display = 'block';
  }
}
showHighlightsCheckbox.addEventListener('change', function () {
  toggleHighlightedArticles(this.checked);
});
function toggleEventLoader(shown) {
  const eventsLoadingWrap = document.querySelector('#eventsLoadingWrap');
  if (eventsLoadingWrap) eventsLoadingWrap.hidden = !shown;
}

/**
 * Called from unicorn component upon successful page load.
 */
// eslint-disable-next-line no-unused-vars
function loadDone() {
  toggleEventLoader(false);
  if (showHighlightsCheckbox.checked) toggleHighlightedArticles(true);

  // TODO: Check instagram, tiktok etc..
  if (window.twttr) window.twttr.widgets.load();
}
window.addEventListener('DOMContentLoaded', () => {
  const eventsLoadingTrigger = document.querySelector('#eventsLoadingTrigger');
  const eventsLoadingWrap = document.querySelector('#eventsLoadingWrap');
  window.addEventListener('scroll', window.debounce(() => {
    if (eventsLoadingWrap.hidden && window.isInViewport(eventsLoadingTrigger)) {
      toggleEventLoader(true);
      window.Unicorn.call('live-events', 'load_next_page');
    }
  }, 200), {
    passive: true
  });
});
sortLiveSelect.querySelector('.dropdown-trigger').addEventListener('click', function (e) {
  this.parentElement.classList.toggle('is-active');
});
const allDropdownItems = [];
const orderMap = {
  'Najnoviji': '-created_date',
  'Najstariji': 'created_date'
};
sortLiveSelect.querySelectorAll('.dropdown-menu .dropdown-item').forEach(dropdownItem => {
  allDropdownItems.push(dropdownItem);
  dropdownItem.addEventListener('click', function (e) {
    e.preventDefault();
    if (this.classList.contains('reorder')) {
      if (showHighlightsCheckbox.checked) {
        showHighlightsCheckbox.checked = false;
        toggleHighlightedArticles(false);
      }
      allDropdownItems.forEach(item => {
        if (item !== this) {
          item.classList.remove('is-active');
        } else {
          item.classList.add('is-active');
        }
      });
      sortLiveSelect.querySelector('.button-name').innerHTML = this.dataset.title;
      toggleEventLoader(true);
      window.Unicorn.call('live-events', 'change_sort', orderMap[this.dataset.title]);
    }
    sortLiveSelect.querySelector('.dropdown-trigger').parentElement.classList.remove('is-active');
  });
});